import React, { createContext, useState, useCallback } from "react";
import { getCarePlansByPatient } from "../../utils/services/Careplans/getCarePlansByPatient";
import { CreateFullCarePlan } from "../../utils/services/Careplans/CreateFullCarePlan";
import { getDiagnosesWithStandard } from "../../utils/services/Careplans/getDiagnosesWithStandard";
import { getCareGoalsByCarePlan } from "../../utils/services/Careplans/getCareGoalsByCarePlan";
import { getTreatmentsByCarePlan } from "../../utils/services/Careplans/getTreatmentsByCarePlan";
import { getFollowUpsByCarePlan } from "../../utils/services/Careplans/getFollowUpsByCarePlan";



export const CarePlanContext = createContext();


export const CarePlanProvider = ({ children }) => {
    const [Careplans, setCareplans] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);


    const createFullCarePlan = async (carePlanData) => {
        setLoading(true);
        setError(null);
        try {
            const response = await CreateFullCarePlan(carePlanData);
            return response; // { message, patientCarePlanId }
        } catch (err) {
            setError(err);
            throw err; // para manejarlo también en el componente si se desea
        } finally {
            setLoading(false);
        }
    };

    const fetchTreatmentsByPlanId = useCallback(async (carePlanId) => {
        setLoading(true);
        setError(null);
        try {
          const treatments = await getTreatmentsByCarePlan(carePlanId);
          return treatments;
        } catch (err) {
          setError(err);
          return [];
        } finally {
          setLoading(false);
        }
      }, []);
    
      const fetchFollowUpsByPlanId = useCallback(async (carePlanId) => {
        setLoading(true);
        setError(null);
        try {
          const followups = await getFollowUpsByCarePlan(carePlanId);
          return followups;
        } catch (err) {
          setError(err);
          return [];
        } finally {
          setLoading(false);
        }
      }, []);

      const fetchDiagnosesWithStandard = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
          const diagnoses = await getDiagnosesWithStandard();
          return diagnoses;
        } catch (err) {
          setError(err);
          return [];
        } finally {
          setLoading(false);
        }
      }, []);

      const fetchCareplans = useCallback(async (cipId) => {
        setLoading(true);
        setError(null);
        try {
          const data = await getCarePlansByPatient(cipId);
          setCareplans(data);
          return data;
        } catch (err) {
          setError(err);
          return null;
        } finally {
          setLoading(false);
        }
      }, []);
    const fetchCareGoalsByPlanId = useCallback(async (carePlanId) => {
        setLoading(true);
        setError(null);
        try {
          const careGoals = await getCareGoalsByCarePlan(carePlanId);
          return careGoals;
        } catch (err) {
          setError(err);
          return [];
        } finally {
          setLoading(false);
        }
      }, []);
    

    return (
        <CarePlanContext.Provider
            value={{
                Careplans,
                loading,
                error,
                fetchCareplans,
                createFullCarePlan, 
                fetchDiagnosesWithStandard,
                fetchCareGoalsByPlanId,
                fetchFollowUpsByPlanId,
                fetchTreatmentsByPlanId,
            }}
        >
            {children}
        </CarePlanContext.Provider>
    );
};

